<template>
<span>
  
  <!-- not clickable as reouterlink  -->
  <div v-if="!to" v-bind:style="{backgroundColor, color}" class="ui-icon">
    <font-awesome-icon v-if="icon" class="icon" v-bind="{ icon }"/>
    <slot></slot>
  </div>
</span>

</template>

<script>


export default {
  name: 'ui-chip',
  props:{
    backgroundColor:{ default:'#FF0000' },
    color:{default:'#FFFFFF'},
    icon:{default:'plus'},
    to:{default:""},
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ui-icon{
  padding:3px 6px;
  border-radius:9999999px;
  display:inline-flex;
  align-items: center;
  justify-content: center;
  font-size:.9em;
}
.icon{
  margin-right:3px;
  
  
}

</style>
